import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabaseClient';

// Notes on a task or job (work_notes), e.g. what crew reported, for managers, owners and admins.
// Pass exactly one of taskId / jobId. The database decides who can read and add them.
export default function WorkNotes({ taskId, jobId, authorEmail }) {
  const parentKey = taskId ? 'task_id' : 'job_id';
  const parentId = taskId || jobId;
  const [notes, setNotes] = useState([]);
  const [text, setText] = useState('');
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    const { data } = await supabase.from('work_notes').select('*').eq(parentKey, parentId).order('created_at');
    setNotes(data || []);
  }, [parentKey, parentId]);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!text.trim()) return;
    setError('');
    const { error } = await supabase.from('work_notes').insert({ [parentKey]: parentId, author_email: authorEmail.toLowerCase(), body: text.trim() });
    if (error) { setError(error.message); return; }
    setText('');
    load();
  };

  return (
    <div className="form-group" data-work-notes>
      <label>Work notes</label>
      {error && <div className="error-msg">{error}</div>}
      {notes.length === 0 && <div style={{ color: '#888', fontSize: 13 }}>No notes yet.</div>}
      {notes.map(n => (
        <div key={n.id} style={{ fontSize: 13, marginBottom: 6 }}>
          <strong>{n.author_email}</strong> · {new Date(n.created_at).toLocaleString()}<br />{n.body}
        </div>
      ))}
      <div style={{ display: 'flex', gap: 8 }}>
        <input value={text} onChange={e => setText(e.target.value)} placeholder="Add a note..." />
        <button type="button" className="btn btn-secondary btn-sm" onClick={add}>Add</button>
      </div>
    </div>
  );
}
